import { Uuid } from "@/domains/global/identifiers";
import {
  MDSIconButton,
  MDSActionMenuDropdown,
  MDSMenuDropdownSlotName,
  MDSIconKind,
  MDSMenuContentList,
} from "@/mds";

export interface ItemListRowActionProps {
  itemId: Uuid;
  dropdown?: MDSMenuContentList;
}

export const ItemListRowDropdown = ({ dropdown }: ItemListRowActionProps) => {
  if (!dropdown || dropdown.length === 0) return null;
  return (
    // Don't propagative hover events to the parent to stop unmounting of this component
    <div
      onMouseEnter={e => e.stopPropagation()}
      onMouseLeave={e => e.stopPropagation()}
      data-name="item-list-row-dropdown"
    >
      <MDSActionMenuDropdown contentList={dropdown} placement="bottom right">
        <MDSIconButton slot={MDSMenuDropdownSlotName.Trigger} iconKind={MDSIconKind.More} />
      </MDSActionMenuDropdown>
    </div>
  );
};
